import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { useAuthStore } from '@/stores/auth-store'

export function useTenant() {
  const user = useAuthStore((s) => s.user)
  const setCurrentTenant = useAuthStore((s) => s.setCurrentTenant)

  return useQuery({
    queryKey: ['tenant', user?.id],
    enabled: !!user?.id,
    queryFn: async () => {
      const { data, error } = await supabase
        .from('tenant_members')
        .select('tenant_id, role, tenants(*)')
        .eq('user_id', user!.id)
        .order('created_at', { ascending: true })
        .limit(1)
        .single()

      if (error) throw error

      const tenant = data.tenants as unknown as import('@/types/supabase').Tables<'tenants'>
      setCurrentTenant(tenant)
      return { ...data, tenant }
    },
  })
}
